<template>
  <div v-if="memberShow" id="PersonalInformation" style="padding: 0 1em">
    <div class="course_title">新申請</div>

    <div class="table-responsive-sm">
      <table class="table" style="width: auto; align: left">
        <tbody>
          <tr>
            <td colspan="4" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。</span
              >
            </td>
          </tr>

          <tr align="left">
            <td colspan="4">
              申請本助學金，家庭年所得不能超過70萬，計算標準比照大專校院弱勢學生入學計畫：<br>
1、未婚者：未成年與其父母或法定監護人合計；已成年與其父母或未成年時之法定監護人合計。<br>
2、已婚者：與其配偶合計。<br>
3、離婚或配偶死亡者：為同學本人之所得總額。<br>
4、其他特殊條件：因父母離婚、遺棄或其他特殊因素，與父母或法定監護人合計顯失公平者，<br>
得敘明理由，並检具相關文件資料（如近３個月內之詳細記事戶籍謄本或其他文件），經學校審查認定後，<br>
該父母或法定監護人免予合計。</td>
          </tr>
          <tr align="left">
            <td>申請日期</td>
            <td>{{ getToday() }}</td>
            <td>申請學年/學期</td>
            <td>{{ queryInfo.schyy }}/{{ queryInfo.smt }}</td>
          </tr>
          <tr align="left">
            <td>編號</td>
            <td>關係人姓名</td>
            <td>與學生關係</td>
            <td>身分證字號</td>
          </tr>

          <tr align="left">
            <td>1</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedName1"
                placeholder="輸入姓名"
              />
            </td>
             <td>
              <div>
                <b-form-select
                  v-model="queryInfo.relatedStudent1"
                  :options="options1"
                ></b-form-select>
              </div>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedId1"
                pattern="/^[A-Z]\d{9}$/"
                placeholder="輸入身分證字號"
                required
              />
            </td>
          </tr>
          <tr align="left">
            <td>2</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedName2"
                placeholder="輸入姓名"
                required
              />
            </td>
             <td>
              <div>
                <b-form-select
                  v-model="queryInfo.relatedStudent2"
                  :options="options2"
                ></b-form-select>
              </div>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedId2"
                pattern="/^[A-Z]\d{9}$/"
                onKeyPress="if(this.value.length==10) return false;"
                placeholder="輸入身分證字號"
                required
              />
            </td>
          </tr>
          <tr align="left">
            <td>3</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedName3"
                placeholder="輸入姓名"
                required
              />
            </td>

            <td>
              <div>
                <b-form-select
                  v-model="queryInfo.relatedStudent3"
                  :options="options3"
                ></b-form-select>
              </div>
            </td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.relatedId3"
                pattern="/^[A-Z]\d{9}$/"
                onKeyPress="if(this.value.length==10) return false;"
                placeholder="輸入身分證字號"
                required
              />
            </td>
          </tr>

          <tr align="left">
            <td><span style="color: #f00">＊</span>戶籍謄本</td>

            <td>
              <b-form-file
                class="mb-2"
                ref="file-input"
                :no-drop="true"
                :no-traverse="true"
                v-model="file"
                @input="fileChange(0)"
                placeholder="上傳戶籍謄本"
                accept="image/jpeg, image/png, image/gif, application/pdf"
              ></b-form-file>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>本人同意</td>

            <td>
              送出申請的文字：
本人確認有中華民國戶籍，就讀本校【產學攜手合作計畫】專班，具有學籍且修業年限內之學生。<br>
同意教育部函請財政部資訊中心查調家庭年所得，若申請後有不符資格者，<br>
願無條件將已獲學校補助之助學金款項繳回，絕無異議。特此聲明。
            </td>
            <td></td>
            <td></td>
          </tr>


          <tr style="text-align: center">
            <td></td>
            <td>
              <button
                class="btn active bg-info text-white rounded"
                @click="addNewCase()"
              >
                送出資料
              </button>
            </td>
            <td>
              <b-button
                style="width: 6.5rem"
                type="reset"
                @click="onReset"
                variant="danger"
                >Reset</b-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else>
    <div class="course_title">請先新增銀行個人資料</div>

    <div class="table-responsive-sm">
      <table class="table" style="width: auto; align: left">
        <tbody></tbody>
      </table>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "AddNewCase",
  // props: [
  //   'memberShow2',
  //   'inputData2'
  // ],
  data() {
    return {
      relatedStudent1: null,
      options1: [
        { value: null, text: "請選擇" },
        { value: 1, text: "父親" },
        { value: 2, text: "母親" },
        { value: 3, text: "配偶" },
        { value: 5, text: "法定代理人" },
      ],
      relatedStudent2: null,
      options2: [
        { value: null, text: "請選擇" },
        { value: 1, text: "父親" },
        { value: 2, text: "母親" },
        { value: 3, text: "配偶" },
        { value: 5, text: "法定代理人" },
      ],
      relatedStudent3: null,
      options3: [
        { value: null, text: "請選擇" },
        { value: 1, text: "父親" },
        { value: 2, text: "母親" },
        { value: 3, text: "配偶" },
        { value: 5, text: "法定代理人" },
      ],
      relatedName1: null,
      relatedName2: null,
      relatedName3: null,
      relatedId1: null,
      relatedId2: null,
      relatedId3: null,
      memberShow: this.$store.state.user2,
      inputData: this.$store.state.inputData,
      inputData2: null,
      mode: false,
      file: null,
      total: 0,
      isIE: false,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        id: "",
        stdID: "",
        Info1: [],
        file: [{ name: "", RowId: "" }],
        sid: "",
        relatedName1: null,
        relatedName2: null,
        relatedName3: null,
        relatedId1: null,
        relatedId2: null,
        relatedId3: null,
        relatedStudent1: 0,
        relatedStudent2: 0,
        relatedStudent3: 0,
        schyy: null,
        smt: null,
        UpdateUser: null,
      },
    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    onReset() {
      let vm = this;
      vm.queryInfo.relatedStudent1 = 0;
      vm.queryInfo.relatedStudent2 = 0;
      vm.queryInfo.relatedStudent3 = 0;
      vm.queryInfo.relatedName1 = "";
      vm.queryInfo.relatedName2 = "";
      vm.queryInfo.relatedName3 = "";
      vm.queryInfo.relatedId1 = "";
      vm.queryInfo.relatedId2 = "";
      vm.queryInfo.relatedId3 = "";
      vm.file = null;
    },
    CaseSelect(id) {
      this.$emit("CaseSelect", id);
    },

    isEmpty(data) {
      return data != '' && data != null && data != undefined
        ? false
        : true;
    },
      FileisEmpty(data) {
      var ret = false;
      if (data instanceof Blob || data instanceof File) {
        if (data.size > 0) {
          ret = true;
        }
      }
      return ret;
    },

    checkVal(str) {
      var regExp = /^[A-Z]\d{9}$/;
      if (regExp.test(str)) return true;
      else return false;
    },
      checkSaveData() {
      var msg = "";

      if (!this.isEmpty(this.queryInfo.relatedId1)) {
        var ret=tools.checkTWID(this.queryInfo.relatedId1);
        if(ret == false)
        {
          msg = this.queryInfo.relatedId1 + "身分證號碼格式不正確，請重寫關係人身分證1";
        }
        if(this.isEmpty(this.queryInfo.relatedName1))
        {
          msg="請輸入姓名";
        }
        else if(this.queryInfo.relatedStudent1 == 0 || this.isEmpty(this.queryInfo.relatedStudent1))
        {
          msg="請選擇與學生關係";
        }

        if(msg != "")
        return msg;

      }

      if (!this.isEmpty(this.queryInfo.relatedId2)) {
        var ret=tools.checkTWID(this.queryInfo.relatedId2);
        if(ret == false)
        {
          msg = this.queryInfo.relatedId2 + "身分證號碼格式不正確，請重寫關係人身分證2";
        }
        if(this.isEmpty(this.queryInfo.relatedName2))
        {
          msg="請輸入姓名";
        }
        else if(this.queryInfo.relatedStudent2 == 0 || this.isEmpty(this.queryInfo.relatedStudent2))
        {
          msg="請選擇與學生關係";
        }

        if(msg != "")
        return msg;

      }

      if (!this.isEmpty(this.queryInfo.relatedId3)) {
        var ret=tools.checkTWID(this.queryInfo.relatedId3);
        if(ret == false)
        {
          msg = this.queryInfo.relatedId3 + "身分證號碼格式不正確，請重寫關係人身分證3";
        }
        if(this.isEmpty(this.queryInfo.relatedName3))
        {
          msg="請輸入姓名";
        }
        else if(this.queryInfo.relatedStudent3 == 0 || this.isEmpty(this.queryInfo.relatedStudent3))
        {
          msg="請選擇與學生關係";
        }

        if(msg != "")
        return msg;

      }
       if ( msg== "" && !this.FileisEmpty(this.file)) {
        msg = "請上傳金融帳戶封面影本";
      }
      return msg;
    },

    fileChange(index) {
      //  var vm = this;
      this.formData = new FormData();
      //  this.formData.delete("header");

      if (index == 0) {
        this.formData.delete("header1");
        this.formData.append("header1", this.file);
      }

      this.$http
        .post("./WebApi/Common/UploadV2", this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) this.queryInfo.Info1 = response.data;
          } else {
            tools.showAlert(vm, "danger", "上傳檔案失敗，請重新上傳" + error);
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗，請重新上傳" + error);
        });
    },
    getToday() {
      var dd = new Date();
      var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var yyyy = dd.getFullYear();
      return tools.stringFormat("{0}/{1}/{2}", yyyy - 1911, mm, today);
    },
    addNewCase: function () {
      var msg = this.checkSaveData();
      if (msg.length != 0) {
        alert(msg);
        return null;
      }

      let vm = this;
      // vm.queryInfo.sid = vm.inputData.usrData.id;

      // vm.queryInfo.schyy = vm.inputData.usrData.schyy;
      // vm.queryInfo.smt = vm.inputData.usrData.smt;

      vm.queryInfo.UpdateUser = vm.inputData.usrData.id;

      //console.log(vm.queryInfo);
      //新增
      this.$http
        .put("./WebApi/EconomicDisadvantage/AddNewCase/", vm.queryInfo)
        .then((response) => {
          if (0 < response.data) {
            alert("新增上傳成功");
            this.CaseSelect(1);
            //   this.$store.dispatch('actionLogin2', vm.memberShow);
            //  this.$store.dispatch('actionLogin2Data', vm.inputData);
            // vm.$router.push({ path:'StdLogin' }) ;
            //window.location.replace("/StdLogin");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
    getReortsSid() {
      let vm = this;

      vm.queryInfo.sid = vm.inputData.usrData.id;
      this.$http
        .get(
          "./WebApi/EconomicDisadvantage/GetReortsSid/".concat(vm.queryInfo.sid)
        )
        .then((response) => {
          if (response.data == null || response.data == 0) {
            vm.memberShow = false;
            alert("請先新增銀行個人資料");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
    GetCurrentSchyy() {
      let vm = this;

      vm.queryInfo.sid = vm.inputData.usrData.id;
      this.$http
        .get("./WebApi/EconomicDisadvantage/GetCurrentSchyy/")
        .then((response) => {
          if (response.data != null && response.data != 0) {
            vm.queryInfo.schyy = response.data.schyy;
            vm.queryInfo.smt = response.data.smt;
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
  },
  created() {
    console.log("======created AddNewCaseView =====");
    this.getReortsSid();
    this.GetCurrentSchyy();
  },
  mounted() {
    console.log("======mounted AddNewCaseView  =====");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
